module.exports = __webpack_public_path__ + "static/img/grow7.60a7e059.png";